import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/yoast': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M91.3 76h186l-7 18.9h-179c-39.7 0-71.9 31.6-71.9 70.3v205.4c0 35.4 24.9 70.3 84 70.3v19.1h-12.1c-50.1 0-91.3-40.2-91.3-89.5v-205.3c0-49.3 40.7-89.2 91.3-89.2zM320.4 20h66.5c-143.8 378.1-145.7 398.9-184.7 439.3-20.8 21.6-49.3 31.7-78.3 32.7v-51.1c49.2-7.7 64.6-49.9 64.6-75.3 0-20.1 0.6-12.6-82.1-223.2h61.4l50.4 156.6zM448 161.5v298.5h-214c6.6-9.6 10.7-16.3 12.1-19.4h182.5v-279.1c0-32.5-17.1-51.9-48.2-62.9l6.7-17.6c41.7 13.6 60.9 43.1 60.9 80.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/yoast.js
// module id = 1112
// module chunks = 0